import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import Input from './Input';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function EmailField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <Input {...props} type="email"/>;
}
